export default {
  api: [
    {
      name: 'accountList',
      method: 'GET',
      desc: '账户列表',
      path: 'account/list'
    },
    {
      name: 'balance',
      method: 'GET',
      desc: '余额信息查询',
      path: 'account/balance'
    },
    {
      name: 'tranList',
      method: 'POST',
      desc: '交易信息列表',
      path: 'tra/list'
    },
    {
      name: 'tranDetail',
      method: 'GET',
      desc: '交易信息详情',
      path: 'tra/detail'
    },
    {
      name: 'tranStatus',
      method: 'GET',
      desc: '交易页签',
      path: 'tra/pageStatus'
    },
    {
      name: 'tranType',
      method: 'GET',
      desc: '交易类型列表',
      path: 'tra/traTypes'
    },
    {
      name: 'export',
      method: 'POST',
      desc: '交易明细导出',
      path: 'tra/export'
    },
    {
      name: 'recharge',
      method: 'POST',
      desc: '充值',
      path: 'account/recharge'
    },
    {
      name: 'withdraw',
      method: 'POST',
      desc: '提现',
      path: 'account/withdraw'
    },
    {
      name: 'accountDetail',
      method: 'GET',
      desc: '账户详情',
      path: 'account/detail'
    },
    {
      name: 'validFee',
      method: 'GET',
      desc: '手续费校验',
      path: 'valid/fee'
    }
  ],
  BASE_URL: '/ccb/pay'
}



// WEBPACK FOOTER //
// ./src/api/apis/member/bank.js